import React from 'react';
import Button from 'react-bootstrap/Button';
import './AboutUs.css';
import aboutImage from '../../image/about/1.jpg';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
} from "react-router-dom";
const AboutUs = () => {
    return (
        <div>
            <div className="container my-5 pt-5">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                        <img src={aboutImage} alt="" />
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-12 my-5 pt-5">
                        <Button variant="light" className="px-5 fw-bold fs-5">About</Button>
                        <div className="about-text my-3">
                            <h2 className="fw-bold text-left">Creative Independent Web Developer</h2>
                            <p>I'm web junior MERN Stack Developer, and I'm very passionate and dedicated to my work.I have acquired the skills and knowledge necessary to make your project a success. I enjoy every step of the design process, from discussion and collaboration</p>
                            <br />
                            <p>Experience in analyzing Designing and integrating Developing front-end  back end based applications. Experience in Front-end application using HTML, CSS3, Bootstrap, Tailwind, Material-UI, JS, ES6, DOM, React js, React from hook, firebase authentication. <br /> I also Back-end developing applications using express Js and Node js and data servers using MongoDB.</p>

                        </div>

                        <Button className="mx-3 mt-3" variant="info"> <Link to="../../file/RIAZ HOSSEN  Resume -part-2.pdf" target="_blank" download>Download-Resume</Link> </Button>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutUs;